const keyCodes = require('../constants/key-codes');
const offcanvasdialog = require('../components/offcanvasdialog');
const lodash = require('../components/custom-lodash');
const addressAutocomplete = require('../components/googlePlacesAutocomplete');
const shipping = require('../pages/checkout/billingshipping');

const MAX_NUMBER_OF_SUGGESTIONS = 5;
const CONFIRMATION_POINT_MAP_ZOOP = 17;

const shippingAddressFields = ['salutation', 'phone', 'address1', 'city', 'postal', 'states_state'];
const weekDaysInOrder = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
const savedShippingForm = {};

const HubBox = {
    currentCollectionPoint: null
};
let autocomplete;
let dialog;

/**
 * Capitalizes the first letter of each word in a given input string.
 *
 * @param {string} input - The input string to be capitalized.
 * @returns {string} - The capitalized string.
 */
function capitalizeWords(input) {
    const words = input.split(' ').filter(word => word);

    const capitalizedWords = words.map(word => {
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    });

    return capitalizedWords.join(' ');
}

/**
 * Formats the opening hours into a readable string.
 *
 * @param {Object} openingHours - Object containing the opening hours for each day.
 * @returns {string[]} - Array of formatted opening hours.
 */
function formatOpeningHours(openingHours) {
    const days = Object.keys(openingHours)
        .filter(day => weekDaysInOrder.indexOf(day) !== -1)
        .map(day => ({
            ...openingHours[day],
            name: day
        }));

    days.sort((a, b) => weekDaysInOrder.indexOf(b) - weekDaysInOrder.indexOf(a));

    const openingHoursLines = [];
    let firstDayIndex = 0;
    while (firstDayIndex < days.length) {
        const currentDay = days[firstDayIndex];
        let lastDayIndex = firstDayIndex;

        while (
            lastDayIndex + 1 < days.length &&
            days[lastDayIndex + 1].open === days[firstDayIndex].open &&
            days[lastDayIndex + 1].close === days[firstDayIndex].close
        ) {
            lastDayIndex++;
        }

        let dayRange;
        if (firstDayIndex !== lastDayIndex && lastDayIndex < days.length) {
            const firstDayTranslated = window.hubboxConfigs.openingDays[days[firstDayIndex].name];
            const lastDayTranslated = window.hubboxConfigs.openingDays[days[lastDayIndex].name];
            dayRange = `${firstDayTranslated} - ${lastDayTranslated}`;
        } else {
            const dayTranslated = window.hubboxConfigs.openingDays[days[firstDayIndex].name];
            dayRange = `${dayTranslated}`;
        }

        let hoursRange;
        if (days[firstDayIndex].open === 'Closed') {
            hoursRange = window.hubboxConfigs.openingDays.closed;
        } else {
            hoursRange = `${currentDay.open}-${currentDay.close}`;
        }

        openingHoursLines.push(`${dayRange} / ${hoursRange}`);
        firstDayIndex = lastDayIndex + 1;
    }

    return openingHoursLines;
}

/**
 * Updates the shipment details with the selected collection point information.
 *
 * @param {Object} collectionPoint - The selected collection point.
 * @param {Function} successCallback - Callback function called on successfull call
 */
function updateShipment(collectionPoint, successCallback) {
    $.ajax({
        url: window.hubboxConfigs.pointSelectedUrl,
        type: 'post',
        dataType: 'json',
        data: {
            collectPointId: collectionPoint ? collectionPoint.id : '',
            collectPointName: collectionPoint ? collectionPoint.name : '',
            collectPointType: collectionPoint ? collectionPoint.meta.type : '',
            collectPointNetwork: collectionPoint ? collectionPoint.meta.network : ''
        },
        /**
         * Handles the response from the HubBox-PointSelected API call.
         *
         * @param {Object} data - The response data.
         */
        success(data) {
            if (data.success) {
                shipping.updateShippingMethodList();
                if (successCallback) {
                    successCallback();
                }
            }
        }
    });
}

/**
 * Clears shipping address form.
 */
function clearShippingForm() {
    shippingAddressFields.forEach(function (fieldName) {
        $(`#dwfrm_singleshipping_shippingAddress_addressFields_${fieldName}`).val('').removeClass('filled-out');
    });

    // Setting controls to default state
    $('#dwfrm_singleshipping_shippingAddress_addToAddressBook').prop('checked', true);
    $('#dwfrm_singleshipping_useDifferentAddress').prop('checked', false);
}

/**
 * Stores shipping address form fields
 */
function saveShippingAddressForm() {
    shippingAddressFields.forEach(function (fieldName) {
        savedShippingForm[fieldName] = $(`#dwfrm_singleshipping_shippingAddress_addressFields_${fieldName}`).val();
    });
    savedShippingForm.addToAddressBook = $('#dwfrm_singleshipping_shippingAddress_addToAddressBook').prop('checked');
    savedShippingForm.useDifferentAddress = $('#dwfrm_singleshipping_useDifferentAddress').prop('checked');
}

/**
 * Swaps between the saved shipping address form and currect shipping address form
 */
function swapShippingAddressForm() {
    const shippingForm = {...savedShippingForm};
    saveShippingAddressForm();

    shippingAddressFields.forEach(function (fieldName) {
        $(`#dwfrm_singleshipping_shippingAddress_addressFields_${fieldName}`).val(shippingForm[fieldName] || '');
    });

    $('#dwfrm_singleshipping_shippingAddress_addToAddressBook').prop('checked', shippingForm.addToAddressBook);
    $('#dwfrm_singleshipping_useDifferentAddress').prop('checked', shippingForm.useDifferentAddress);
}

/**
 * Main callback called when a Click & Collect location has been selected.
 * Populates the shipping form with the collection point information.
 *
 * @param {Object} cp - The selected collection point.
 */
function hubBoxPointSelectedCallback(cp) {
    const $hbPickupConfirmation = $('.hubbox-pickup-confirmation').removeClass('hidden');
    const capitalizedAddress = capitalizeWords(`${cp.address.street1}, ${cp.address.city}`);
    const addressLine = `${capitalizedAddress}, ${cp.address.region} ${cp.address.postcode}, ${cp.address.country}`;

    HubBox.currentCollectionPoint = cp;

    $hbPickupConfirmation
        .find('.hubbox-point-name')
        .html(`${cp.shortName} <span class="distance">(${cp.distance.toFixed(2)} km)</span`);
    $hbPickupConfirmation.find('.hubbox-point-address').text(addressLine);
    $hbPickupConfirmation.find('.hubbox-point-phone').text(cp.telephone);
    $hbPickupConfirmation.find('.hubbox-point-hours').html(formatOpeningHours(cp.openingHours).join('<br/>'));

    const mapParam = {
        zoomLevel: CONFIRMATION_POINT_MAP_ZOOP,
        mapCenter: [cp.address.point.lat, cp.address.point.lon],
        markers: [{pin: 'ups', latLng: [cp.address.point.lat, cp.address.point.lon], isActive: true}]
    };
    $('.hubbox-point-map iframe').prop(
        'src',
        `${window.hubboxConfigs.frameUrl}?staticMap=${encodeURIComponent(JSON.stringify(mapParam))}&configID=${
            window.hubboxConfigs.configId
        }`
    );

    // Pupulate the shipping address fields with the collection point information
    $('#dwfrm_singleshipping_shippingAddress_addressFields_salutation').val('None');
    $('#dwfrm_singleshipping_shippingAddress_addressFields_address1').val(capitalizeWords(cp.address.street1));
    $('#dwfrm_singleshipping_shippingAddress_addressFields_city').val(capitalizeWords(cp.address.city));
    $('#dwfrm_singleshipping_shippingAddress_addressFields_postal').val(cp.address.postcode);
    $('#dwfrm_singleshipping_shippingAddress_addressFields_states_state').val(cp.address.region);

    // Try to get the phone number from billing address
    const $shippingPhonField = $('#dwfrm_singleshipping_shippingAddress_addressFields_phone');
    if (!$shippingPhonField.val()) {
        const billingPhone = $('#dwfrm_singleshipping_billingAddress_addressFields_phone').val();
        if (billingPhone) {
            $shippingPhonField.val(billingPhone);
        } else {
            const $selectedBillingAddress = $('.jsBillingAddressArea .jsAddressSelection .jsActionSelect').find(
                'input:checked'
            );
            if ($selectedBillingAddress.length) {
                $('#dwfrm_singleshipping_shippingAddress_addressFields_phone').val(
                    $selectedBillingAddress.data('address').phone
                );
            }
        }
    }

    // Ensure that collection point address is not going to be saved to address book
    $('#dwfrm_singleshipping_shippingAddress_addToAddressBook').prop('checked', false);

    // Ensure that that we are not using collection point address as billing address
    $('#dwfrm_singleshipping_useDifferentAddress').prop('checked', true);

    // Populate the address search input with the pickup poin address
    $('#hubbox-search-input').val(addressLine).trigger('blur');

    updateShipment(cp, () => {
        $('.checkout-continue button').prop('disabled', false);
    });

    // Track Pickup Point selected
    if (window.dataLayer) {
        window.dataLayer.push({
            event: 'hubBox_pickupPointSelected'
        });
    }
}

/**
 * Confirms the selected collection point using the SingleWidgetManager.
 *
 * @param {Object} cp - The confirmed collection point.
 */
function confirmCollectionPointSingleWidget(cp) {
    sessionStorage.setItem('hubBox_cp', JSON.stringify(cp));

    hubBoxPointSelectedCallback(cp);

    if (!window.hubbox) {
        window.hubbox = {};
    } else {
        window.hubbox.collectPoint = cp;
    }

    dialog.hide();

    if (HubBox.widget) {
        HubBox.widget.events.emit(HubBox.widget.topics.emit.RESET_STATE);
    }
}

/**
 * Creates a SingleWidget for collection point search and confirmation.
 *
 * @param {string} query - The search query for the widget.
 * @param {Function|null} readyCallback - Function to be called when widget is loaded
 */
function createSingleWidget(query, readyCallback) {
    const SWContainer = $('.ocd-flyin .hubbox-widget');

    const iframeUrl = HubBox.frameUrl;
    const {configId} = HubBox;

    const singleWidgetOptions = {
        container: SWContainer.get(0),
        iframeUrl,
        iframeParams: {
            configId,
            locale: window.hubboxConfigs.locale
        }
    };

    if (query) {
        singleWidgetOptions.iframeParams.searchQuery = query;
    }

    const SWM = new window.SingleWidgetManager(singleWidgetOptions);

    SWM.events.subscribe(SWM.topics.subscribe.COLLECT_POINT_CONFIRMED, messageAndTopic =>
        confirmCollectionPointSingleWidget(messageAndTopic.message)
    );

    if (readyCallback) {
        SWM.events.subscribe(SWM.topics.subscribe.WIDGET_READY, readyCallback);
    }

    HubBox.widget = SWM;
}

/**
 * Starts the search for collection points.
 *
 * @param {string} query - The search query.
 * @param {Function} callback - Callback function called after widget is displayed
 */
function startSearch(query, callback) {
    dialog.loadContent($('.hubbox-overlay'), function () {
        createSingleWidget(query, () => {
            dialog.show();
            if (callback) {
                callback();
            }
            // Track Pickup Point flyout opened
            if (window.dataLayer) {
                window.dataLayer.push({
                    event: 'hubBox_pickupPointFlyoutDisplayed'
                });
            }
        });
    });
}

/**
 * Handles input for the search field and displays autocomplete suggestions.
 *
 */
function handleSearchInput() {
    const $input = $(this);
    const searchTerm = $input.val();
    const $suggestions = $input.closest('.hubbox-search-row').find('.hubbox-search-suggestions');

    if (searchTerm.length) {
        autocomplete.getPlacePredictions(searchTerm).then(result => {
            $suggestions.empty();
            if (result.predictions && result.predictions.length) {
                result.predictions.slice(0, MAX_NUMBER_OF_SUGGESTIONS).forEach(function (place) {
                    $suggestions.append(
                        $(
                            `<li id="${place.place_id}" role="option" class="search-suggestion" aria-selected="false">${place.description}</li>`
                        )
                    );
                });
                $input.attr('aria-expanded', 'true');
            }
        });
    } else {
        $input.attr('aria-expanded', 'false');
        $suggestions.empty();
    }
}
/**
 * Checks whether collection point shipping is currently selected
 *
 * @returns {boolean} - True if collection point shipping is selected
 */
function isCollectionPointShippingSelected() {
    return $('#radio-shipping-pickup-point').is(':checked');
}

/**
 * Handles shipping type change
 *
 */
function handleShippingTypeChange() {
    swapShippingAddressForm();

    if (isCollectionPointShippingSelected()) {
        $('.use-same-address-row input').prop('checked', true);
        $('.jsShippingAddressForm').show();
        $('.jsBillingAddressArea').show();
        $('#newShippingAddress').prop('checked', true);

        // Track Pickup Point option selected
        if (window.dataLayer) {
            window.dataLayer.push({
                event: 'hubBox_pickupPointOptionSelected'
            });
        }
    } else {
        if (!$('.use-same-address-row input').is(':checked')) {
            $('.jsBillingAddressArea').hide();
        }
        if ($('#newShippingAddress').length && !$('#newShippingAddress').is(':checked')) {
            $('.jsShippingAddressForm').hide();
        }
    }
}

/**
 * Initializes the HubBox component and sets up event listeners.
 */
function init() {
    HubBox.configId = window.hubboxConfigs.configId;
    HubBox.frameUrl = window.hubboxConfigs.frameUrl;

    dialog = offcanvasdialog.init(false, {
        overlay: true,
        headerStyle: 'over',
        additionalClass: 'hubbox-ocd'
    });

    const $hubboxSearchInput = $('#hubbox-search-input');
    const $hubboxSearchsuggestions = $hubboxSearchInput
        .closest('.hubbox-search-row')
        .find('.hubbox-search-suggestions');

    $hubboxSearchInput.on('keydown', function (e) {
        if (e.which === keyCodes.ENTER) {
            startSearch($(this).val());
            e.preventDefault();
        }
    });

    if (addressAutocomplete.enabled) {
        let originalValue = '';
        autocomplete = addressAutocomplete.getAutocompleteService();
        $hubboxSearchInput.on('input', lodash.debounce(handleSearchInput, 100)).on('keydown', function (e) {
            if (e.which === keyCodes.DOWN || e.which === keyCodes.UP) {
                const $selectedOption = $hubboxSearchsuggestions.find('.search-suggestion[aria-selected="true"]');
                if ($selectedOption.length) {
                    $selectedOption.attr('aria-selected', 'false');
                    const $nextOption = e.which === keyCodes.DOWN ? $selectedOption.next() : $selectedOption.prev();
                    if ($nextOption.length) {
                        $nextOption.attr('aria-selected', 'true');
                        $hubboxSearchInput
                            .val($nextOption.text())
                            .attr('aria-activedescendant', $nextOption.attr('id'));
                    } else {
                        $hubboxSearchInput.val(originalValue).attr('aria-activedescendant', '');
                    }
                } else if (!$hubboxSearchsuggestions.is(':empty')) {
                    originalValue = $hubboxSearchInput.val();
                    const $suggestions = $hubboxSearchsuggestions.find('.search-suggestion');
                    const $nextOption = e.which === keyCodes.DOWN ? $suggestions.first() : $suggestions.last();
                    $nextOption.attr('aria-selected', 'true');
                    $hubboxSearchInput.val($nextOption.text()).attr('aria-activedescendant', $nextOption.attr('id'));
                }
            } else if (e.which === keyCodes.ESCAPE) {
                $hubboxSearchInput.val(originalValue).attr('aria-expanded', 'false').attr('aria-activedescendant', '');
                $hubboxSearchsuggestions.empty();
            } else if (e.which === keyCodes.ENTER) {
                const $selectedOption = $hubboxSearchsuggestions.find('.search-suggestion[aria-selected="true"]');
                originalValue = $selectedOption.text();
                $hubboxSearchInput.val($selectedOption.text()).attr('aria-activedescendant', '');
                $hubboxSearchsuggestions.empty();
            }
        });
        $hubboxSearchsuggestions.on('click', '.search-suggestion', function () {
            const suggestion = $(this).text();
            $hubboxSearchInput.val(suggestion).attr('aria-expanded', 'false').attr('aria-activedescendant', '');
            $hubboxSearchsuggestions.empty();
            startSearch(suggestion);
        });
    }

    $('#hubbox-current-location').on('click', function (e) {
        navigator.geolocation.getCurrentPosition(function (position) {
            startSearch(null, () => {
                HubBox.widget.events.emit(HubBox.widget.topics.emit.MAP_LATLNG_QUERY, [
                    Number(position.coords.latitude),
                    Number(position.coords.longitude)
                ]);
            });
        });
        e.preventDefault();
    });

    $('#hubbox-search-button, .hubbox-point-change-location').on('click', function (e) {
        startSearch($('#hubbox-search-input').val());
        e.preventDefault();
    });

    // Duplicate billing phone into the shipping phone as we don't have a phone input for a pickup point
    $('#dwfrm_singleshipping_billingAddress_addressFields_phone').on('change', function () {
        if ($('#radio-shipping-pickup-point').is(':checked')) {
            $('#dwfrm_singleshipping_shippingAddress_addressFields_phone').val($(this).val());
        }
    });

    $('input[name=shipping-type]').on('change', handleShippingTypeChange);

    $('#dwfrm_singleshipping_shippingAddress').on('submit', function () {
        if (isCollectionPointShippingSelected()) {
            updateShipment(HubBox.currentCollectionPoint);
        } else {
            updateShipment();
            sessionStorage.removeItem('hubBox_cp');
        }
    });

    // Restore the collection point confirmation
    if (sessionStorage.hubBox_cp) {
        const collectionPoint = JSON.parse(sessionStorage.hubBox_cp);

        // Clear the shipping form as it's populated by previously selected collection point
        clearShippingForm();
        handleShippingTypeChange();
        hubBoxPointSelectedCallback(collectionPoint);
    }
}

module.exports.init = init;
